module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_clubs-7.2bbd7906.svg";